import { atom } from 'recoil';

import { defaultParams, initialSelectedOption } from '../constants';
import { MovementOptionQuery, MovementsFilterParamsProps } from '../types';

export const movementOptionQueryState = atom({
  key: 'movementOptionQueryState',
  default: initialSelectedOption as MovementOptionQuery,
});

export const movementsFilterParamsState = atom({
  key: 'movementsFilterParamsState',
  default: { ...defaultParams } as MovementsFilterParamsProps,
});
